import {atom} from "recoil";
import {
    ExceptionListAncillaryExceptions,
    FormSearchExceptionListAncillaryExceptionModel
} from "../api/types/exceptionListAncillaryExceptionModel";

export const selectedExceptionListAncillaryExceptionAtom = atom<ExceptionListAncillaryExceptions | null>({
    key: "selectedExceptionListAncillaryExceptionAtom",
    default: null
});

export const defaultSearchedExceptionListAncillaryException = {
    exceptionListName: "",
    exceptionName: "",
    dealers: [],
    legalEntities: []
};
export const searchedExceptionListAncillaryExceptionAtom = atom<FormSearchExceptionListAncillaryExceptionModel>({
    key: "searchedExceptionListAncillaryExceptionAtom",
    default: defaultSearchedExceptionListAncillaryException
});